// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"CompanyEmployeesPage_pageWrapper__327IF"};